import { render, staticRenderFns } from "./cms-block-word-page.vue?vue&type=template&id=211b27eb&scoped=true"
import script from "./cms-block-word-page.vue?vue&type=script&lang=js"
export * from "./cms-block-word-page.vue?vue&type=script&lang=js"
import style0 from "./cms-block-word-page.vue?vue&type=style&index=0&id=211b27eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211b27eb",
  null
  
)

export default component.exports